import { render } from "./Services-business-owner-en.vue?vue&type=template&id=8970d4f8&scoped=true"
import script from "./Services-business-owner-en.vue?vue&type=script&lang=js"
export * from "./Services-business-owner-en.vue?vue&type=script&lang=js"

import "./Services-business-owner-en.vue?vue&type=style&index=0&id=8970d4f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8970d4f8"]])

export default __exports__